import React from "react";

export default function HeartView({ count = 0 }) {
  if (count >= 3) {
    return <span style={{ fontSize: "1.25rem" }}>🥰</span>;
  }

  return (
    <span style={{ display: "flex", gap: "0.25rem", alignItems: "center" }}>
      {[1, 2, 3].map((n) => (
        <span
          key={n}
          style={{
            color: n <= count ? "#E85D75" : "#EFD6DB",
            fontSize: "1.05rem",
            display: "inline-block",
            background: "#FFF5F7",
            borderRadius: "999px",
            padding: "0.12rem 0.28rem",
            lineHeight: 1,
          }}
        >
          ♥
        </span>
      ))}
    </span>
  );
}